/* ============================================================================
   FACHA POSTA - Carrito lateral.

   REPARTO DE TAREAS (importante, esto explica todo el archivo)
   ------------------------------------------------------------
   El pie del cajon se RECONSTRUYE ENTERO desde el HTML del servidor en cada
   cambio del carrito: theme.js:1711 hace
       this.querySelector('[slot="footer"]').replaceChildren(...)
   El DIV del pie sobrevive; TODOS sus hijos se tiran y se vuelven a crear.

   Por eso el markup del pie (acordeones, "combinalo con", sello) va en LIQUID,
   dentro de sections/cart-drawer.liquid. Vuelve solo, con datos frescos y en su
   lugar. Este archivo NO construye nada del pie: solo engancha comportamiento y
   devuelve el estado del usuario despues de cada redibujo.

   La UNICA pieza que se sigue inyectando por JS es la banda de reserva, que vive
   arriba (.cart-drawer__top) y no depende de datos del servidor.

   REGLA QUE COSTO CARO EN TIMEFIT: nunca se MUEVEN nodos del tema con JS.
   SEGUNDA REGLA, aprendida aca: el observador mira childList sobre la seccion,
   asi que este archivo no crea ni borra nodos dentro del pie. Solo cambia
   clases, atributos y valores. Crear nodos ahi adentro se retroalimenta solo.
   ========================================================================== */
(function () {
  'use strict';

  var MINUTOS = 10;
  var LLAVE = 'fp_carrito_reserva';
  var LLAVE_RECARGA = 'fp_carrito_recalculado';
  var reloj = null;

  /* Estado del usuario que hay que sobrevivir a cada redibujo del pie.
     null = el usuario nunca lo toco, manda lo que diga el servidor. */
  var estado = { regalo: null, desc: null, nota: null, codigo: '', on: {}, pag: 0 };
  var guardaNota = null;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function raiz() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function jsonPost(url, cuerpo, extra) {
    var h = { 'Content-Type': 'application/json', Accept: 'application/json' };
    if (extra) for (var k in extra) h[k] = extra[k];
    return fetch(raiz() + url, { method: 'POST', headers: h, body: JSON.stringify(cuerpo) });
  }

  var RELOJ = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2" stroke-linecap="round"/></svg>';

  /* ---------- 0. DESCUENTOS VENCIDOS ----------
     Un carrito abandonado guarda congelado el descuento con el que se armo:
     Shopify no lo reevalua hasta que el carrito se toca. Cobrar de menos nunca
     pasa (el checkout recalcula), pero la clienta ve un precio en el carrito y
     otro al pagar. Cualquier POST a cart/update.js fuerza el recalculo. */
  var yaRecalculo = false;
  function limpiarDescuentosVencidos(cart) {
    if (yaRecalculo) return;
    yaRecalculo = true;
    var aplicados = cart && cart.cart_level_discount_applications;
    if (!aplicados || !aplicados.length) return;
    var antes = cart.total_price;

    jsonPost('cart/update.js', { attributes: {} })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || c.total_price === antes) return;   // seguia vigente: no se toca
        if ($('cart-drawer[open]')) return;          // no redibujar en la cara del cliente
        var marca;
        try { marca = sessionStorage.getItem(LLAVE_RECARGA); } catch (e) { marca = null; }
        if (!marca) {
          try { sessionStorage.setItem(LLAVE_RECARGA, '1'); } catch (e) {}
          location.reload();
        }
      })
      .catch(function () {});
  }

  /* ---------- 1. RESERVA ----------
     El timer NO se reinicia al llegar a cero: pasa a "sigue guardado".
     Ojo: Shopify no reserva stock de verdad, la frase es presion, no un hecho. */
  function arranque() {
    var t;
    try { t = sessionStorage.getItem(LLAVE); } catch (e) { t = null; }
    if (!t) {
      t = String(Date.now());
      try { sessionStorage.setItem(LLAVE, t); } catch (e) {}
    }
    return Number(t);
  }

  /* Los textos van en UNA linea (la banda lleva white-space:nowrap): partidos en
     dos ocupaban 43px en vez de 28. Por eso el mensaje de vencido es corto: el
     largo llegaba justo al borde y en un telefono de 360px se cortaba. */
  function pintarReserva(nodo) {
    var falta = (arranque() + MINUTOS * 60000) - Date.now();
    if (falta <= 0) {
      nodo.className = 'fpc-hold fpc-hold--fin';
      nodo.innerHTML = RELOJ + '<span>Tu carrito sigue guardado</span>';
      return false;
    }
    var t = Math.floor(falta / 1000), m = Math.floor(t / 60), s = t % 60;
    nodo.className = 'fpc-hold';
    nodo.innerHTML = RELOJ + '<span>Tu carrito está reservado por <b>' +
      m + ':' + (s < 10 ? '0' + s : s) + '</b> min</span>';
    return true;
  }

  function pararReloj() { if (reloj) { clearInterval(reloj); reloj = null; } }

  /* ---------- 2. NOTA DE REGALO ----------
     Se guarda sola mientras escribe. No hace falta redibujar: la nota no cambia
     ningun total, asi que un POST callado alcanza y no le mueve el cajon. */
  function guardarNota(ta) {
    clearTimeout(guardaNota);
    var ok = ta.parentElement ? $('.fpc-nota__ok', ta.parentElement) : null;
    guardaNota = setTimeout(function () {
      jsonPost('cart/update.js', { note: ta.value })
        .then(function () {
          if (!ok) return;
          ok.hidden = false;
          setTimeout(function () { ok.hidden = true; }, 1600);
        })
        .catch(function () {});
    }, 700);
  }

  /* ---------- 3. CODIGO DE DESCUENTO ----------
     Desde el 21-may-2025 cart/update.js acepta {discount}. Verificado contra la
     tienda real: un codigo invalido vuelve como {applicable:false}, asi que se
     puede avisar SIN sacar a la clienta del cajon.
     Ojo: update.js REEMPLAZA la lista entera de codigos, no suma: hay que mandar
     los que ya estaban vigentes junto con el nuevo. */
  function aviso(msg, texto) {
    if (!msg) return;
    msg.textContent = texto;
    msg.hidden = false;
  }

  function aplicarCodigo(pie) {
    var inp = $('.fpc-desc__in', pie);
    var btn = $('.fpc-desc__btn', pie);
    var msg = $('.fpc-desc__msg', pie);
    if (!inp || !btn) return;

    var code = (inp.value || '').trim();
    if (!code) { aviso(msg, 'Escribí un código.'); return; }

    var etiqueta = btn.textContent;
    function soltar() { btn.disabled = false; btn.textContent = etiqueta; }
    btn.disabled = true;
    btn.textContent = 'Aplicando…';
    if (msg) msg.hidden = true;

    /* El flag separa "fallo la red" de "fallo el redibujo": sin el, un error
       del propio redibujo mandaba a navegar y se comia el cajon. */
    var huboRespuesta = false;

    fetch(raiz() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var vigentes = (c.discount_codes || [])
          .filter(function (d) { return d.applicable; })
          .map(function (d) { return d.code; });
        if (vigentes.indexOf(code) === -1) vigentes.push(code);
        return jsonPost('cart/update.js', { discount: vigentes.join(',') });
      })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        huboRespuesta = true;
        var mio = (c.discount_codes || []).filter(function (d) {
          return String(d.code).toLowerCase() === code.toLowerCase();
        })[0];

        if (!mio || !mio.applicable) {
          aviso(msg, 'Ese código no sirve para este carrito.');
          soltar();
          /* Se saca el invalido para que no quede pegado al carrito. */
          var ok = (c.discount_codes || [])
            .filter(function (d) { return d.applicable; })
            .map(function (d) { return d.code; });
          return jsonPost('cart/update.js', { discount: ok.join(',') }).catch(function () {});
        }

        estado.codigo = '';
        estado.desc = true;              // queda abierto para que vea el resultado
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {
        if (!huboRespuesta) aviso(msg, 'No se pudo aplicar. Probá de nuevo.');
        soltar();
      });
  }

  /* ---------- 4. COMBINALO CON ----------
     Nada de esto crea ni borra nodos: solo clases, atributos y valores. */
  function encender(it, on) {
    it.classList.toggle('is-on', on);
    var sw = $('.fpc-up__sw', it);
    if (sw) sw.setAttribute('aria-checked', on ? 'true' : 'false');
    var exp = $('.fpc-up__exp', it);
    if (exp) exp.hidden = !on;
  }

  function refrescarPrecio(it, sel) {
    var op = sel.selectedOptions && sel.selectedOptions[0];
    var hoy = $('.fpc-up__hoy', it);
    if (op && hoy && op.dataset.pr) hoy.textContent = op.dataset.pr;
  }

  function marcarDot(up, i) {
    $$('.fpc-up__dot', up).forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
  }

  function agregar(it, vid, btn) {
    if (!vid) return;                                   // select vacio: no se manda basura
    var etiqueta = btn.textContent;
    btn.disabled = true;
    if (btn.classList.contains('fpc-up__add')) btn.textContent = '…';

    /* X-Requested-With es lo que hace que Shopify controle stock (theme.js:2707). */
    jsonPost('cart/add.js', { id: Number(vid), quantity: 1 }, { 'X-Requested-With': 'XMLHttpRequest' })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'sin stock');
          return d;
        });
      })
      .then(function () {
        delete estado.on[it.dataset.pid];
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {
        btn.disabled = false;
        if (btn.classList.contains('fpc-up__add')) {
          btn.textContent = 'Sin stock';
          setTimeout(function () { btn.textContent = etiqueta; }, 2000);
        } else {
          encender(it, false);
          delete estado.on[it.dataset.pid];
        }
      });
  }

  /* ---------- 5. ENGANCHE DEL PIE ----------
     Los listeners van DELEGADOS sobre el div del pie, que sobrevive al
     replaceChildren: asi un redibujo no obliga a re-enganchar nada.
     'toggle' y 'scroll' no burbujean, por eso van en fase de captura. */
  function engancharPie(pie) {
    if (pie.__fpcWired) return;
    pie.__fpcWired = 1;

    pie.addEventListener('click', function (e) {
      var sw = e.target.closest('.fpc-up__sw');
      if (sw) {
        var it = sw.closest('.fpc-up__it');
        var pid = it.dataset.pid;
        if (it.classList.contains('is-on')) { encender(it, false); delete estado.on[pid]; return; }
        var sel = $('.fpc-up__sel', it);
        encender(it, true);
        if (sel) { estado.on[pid] = sel.value; refrescarPrecio(it, sel); }
        else { estado.on[pid] = it.dataset.vid; agregar(it, it.dataset.vid, sw); }
        return;
      }

      var add = e.target.closest('.fpc-up__add');
      if (add) {
        var it2 = add.closest('.fpc-up__it');
        var sel2 = $('.fpc-up__sel', it2);
        agregar(it2, sel2 ? sel2.value : it2.dataset.vid, add);
        return;
      }

      var dot = e.target.closest('.fpc-up__dot');
      if (dot) {
        var up = dot.closest('.fpc-up');
        var tr = $('.fpc-up__tr', up);
        var i = Number(dot.dataset.i) || 0;
        estado.pag = i;
        if (tr) tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' });
        marcarDot(up, i);
        return;
      }

      if (e.target.closest('.fpc-desc__btn')) aplicarCodigo(pie);
    });

    pie.addEventListener('change', function (e) {
      var sel = e.target.closest('.fpc-up__sel');
      if (!sel) return;
      var it = sel.closest('.fpc-up__it');
      estado.on[it.dataset.pid] = sel.value;
      refrescarPrecio(it, sel);
    });

    pie.addEventListener('input', function (e) {
      if (e.target.closest('.fpc-nota')) { estado.nota = e.target.value; guardarNota(e.target); return; }
      if (e.target.closest('.fpc-desc__in')) estado.codigo = e.target.value;
    });

    pie.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.closest('.fpc-desc__in')) { e.preventDefault(); aplicarCodigo(pie); }
    });

    pie.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || !d.id) return;
      if (d.id === 'fpc-acc-regalo') estado.regalo = d.open;
      if (d.id === 'fpc-acc-desc') estado.desc = d.open;
    }, true);

    var pendScroll = null;
    pie.addEventListener('scroll', function (e) {
      var tr = e.target && e.target.classList && e.target.classList.contains('fpc-up__tr') ? e.target : null;
      if (!tr) return;
      clearTimeout(pendScroll);
      pendScroll = setTimeout(function () {
        var i = Math.round(tr.scrollLeft / Math.max(tr.clientWidth, 1));
        estado.pag = i;
        marcarDot(tr.closest('.fpc-up'), i);
      }, 120);
    }, true);
  }

  /* ---------- 6. DEVOLVER EL ESTADO DESPUES DEL REDIBUJO ---------- */
  function restaurarPie(pie) {
    /* <details> pelado a proposito: escribirle .open no anima nada. Con el
       acordeon del tema esto parpadeaba 250ms en cada +/- de cantidad. */
    var r = $('#fpc-acc-regalo', pie);
    if (r && estado.regalo !== null && r.open !== estado.regalo) r.open = estado.regalo;
    var d = $('#fpc-acc-desc', pie);
    if (d && estado.desc !== null && d.open !== estado.desc) d.open = estado.desc;

    var ta = $('.fpc-nota', pie);
    if (ta && estado.nota !== null && ta.value !== estado.nota) ta.value = estado.nota;
    var inp = $('.fpc-desc__in', pie);
    if (inp && estado.codigo && inp.value !== estado.codigo) inp.value = estado.codigo;

    var up = $('.fpc-up', pie);
    if (!up) return;

    Object.keys(estado.on).forEach(function (pid) {
      var it = $('.fpc-up__it[data-pid="' + pid + '"]', up);
      if (!it) { delete estado.on[pid]; return; }       // ya esta en el carrito o se agoto
      var sel = $('.fpc-up__sel', it);
      if (sel) {
        sel.value = estado.on[pid];
        if (!sel.value) { delete estado.on[pid]; return; }  // esa variante ya no existe
        refrescarPrecio(it, sel);
      }
      encender(it, true);
    });

    var tr = $('.fpc-up__tr', up);
    if (tr && estado.pag) {
      var pags = Number(up.dataset.pags) || 1;
      var i = Math.min(estado.pag, pags - 1);
      if (i > 0 && tr.clientWidth) { tr.scrollLeft = i * tr.clientWidth; marcarDot(up, i); }
    }
  }

  /* ---------- 7. MEDIR EL PADDING REAL ----------
     La banda va de borde a borde y necesita el sangrado EXACTO.
     Escribirlo a mano fallo dos veces en Timefit: se mide. */
  function medirPadding(cajon) {
    /* El padding NO esta en .cart-drawer__top (mide 0): la columna de contenido
       va centrada dentro del cajon. Por eso se mide la distancia real entre el
       borde interno del cajon y el borde de la columna. */
    var ref = $('.cart-drawer__top', cajon) || $('.cart-drawer__inner', cajon);
    if (!ref) return;
    var a = cajon.getBoundingClientRect(), b = ref.getBoundingClientRect();
    if (a.width < 60 || b.width < 60 || b.width > a.width) return;  // cajon sin layout
    var e = getComputedStyle(cajon);
    var bl = parseFloat(e.paddingLeft) || 0, br = parseFloat(e.paddingRight) || 0;
    /* Los dos lados se miden por separado: la columna de este cajon no siempre
       queda centrada, y un solo valor dejaba la banda corta de un lado. */
    var izq = Math.round(b.left - a.left - bl);
    var der = Math.round(a.right - br - b.right);
    if (izq < 0 || izq > 80 || der < 0 || der > 80) return;         // medida absurda
    var css = document.documentElement.style;
    css.setProperty('--fpc-pad', izq + 'px');
    css.setProperty('--fpc-pad-r', der + 'px');
  }

  /* El cajon cambia de ancho al abrirse: hay que volver a medir en ese momento. */
  function vigilarApertura(cajon) {
    if (!cajon || cajon.__fpcObs) return;
    cajon.__fpcObs = true;
    new MutationObserver(function () {
      if (cajon.hasAttribute('open')) medirPadding(cajon);
    }).observe(cajon, { attributes: true, attributeFilter: ['open'] });
  }

  /* ---------- 8. ARMADO ---------- */
  function armar() {
    var cajon = $('cart-drawer');
    if (!cajon) return;                       // en /cart no existe el cajon
    if (!$('.cart-drawer__inner', cajon)) { pararReloj(); return; }  // carrito vacio

    medirPadding(cajon);
    vigilarApertura(cajon);

    /* Reserva: arriba, antes de la barra de envio. Unica pieza inyectada. */
    var top = $('.cart-drawer__top', cajon);
    if (top && !$('.fpc-hold', cajon)) {
      var band = document.createElement('div');
      var barra = $('free-shipping-bar', top);
      if (barra) top.insertBefore(band, barra); else top.appendChild(band);
      if (pintarReserva(band)) {
        pararReloj();
        reloj = setInterval(function () {
          var n = $('.fpc-hold', document);
          if (!n) { pararReloj(); return; }
          if (!pintarReserva(n)) pararReloj();
        }, 1000);
      }
    }

    /* Pie: el markup ya vino del servidor. Aca solo se engancha y se restaura. */
    var pie = $('[slot="footer"]', cajon);
    if (pie) { engancharPie(pie); restaurarPie(pie); }
  }

  /* ---------- 9. EL CAJON SE REDIBUJA ----------
     El observer va acotado a la SECCION, no al <cart-drawer>: al actualizar el
     carrito el propio <cart-drawer> se reemplaza entero y un observador colgado
     de el se quedaria mirando un nodo que ya no esta en la pagina. */
  function observar() {
    var cajon = $('cart-drawer');
    var sec = cajon && cajon.closest('[id^="shopify-section"]');
    var blanco = sec || document.body;
    var pend = null;
    new MutationObserver(function () {
      clearTimeout(pend);
      pend = setTimeout(armar, 60);
    }).observe(blanco, { childList: true, subtree: true });
  }

  function empezar() {
    armar();
    observar();
    window.addEventListener('resize', function () {
      var c = $('cart-drawer'); if (c) medirPadding(c);
    });
    /* El pedido del carrito se hace SIEMPRE, aunque no haya cajon: en /cart no
       existe <cart-drawer> y la limpieza de descuentos igual tiene que correr. */
    fetch(raiz() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(limpiarDescuentosVencidos)
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', empezar);
  } else { empezar(); }
})();
